import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import boxStyles from '../../../styles/boxStyles';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import SelectMap from './SelectMap';
import ApiService from '../../../services/ApiService';
import fieldStyles from '../../../styles/fieldStyles';
import SimpleMDE from 'react-simplemde-editor';
import 'easymde/dist/easymde.min.css';
import HipoTable from './HipoTable';

// var simplemde = new SimpleMDE({
//   spellChecker: false,
//   hideIcons: ["link", "image", "preview", "fullscreen", "guide"],
// });

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const InformasiKejadian = ({
  setShowRecordable,
  inputFields,
  setInputFields,
  listAllKategoriInsiden,
  selectedKategoriInsiden,
  setSelectedKategoriInsiden,
  readOnly = false,
  enableOpenMap = true,
  enableEditMap = true,
}) => {
  // Format Kategori Insiden
  const handleChangeKategoriInsiden = (event, idKategoriInsiden) => {
    const { value } = event.target;
    // Mencari index di selected
    let idx = selectedKategoriInsiden
      .map((sItem) => sItem.detailKategoriInsidenId)
      .indexOf(
        value.length > 1 ? value[selectedKategoriInsiden.length] : value[0]
      );

    // Jika ada
    if (idx > -1) {
      setSelectedKategoriInsiden((current) =>
        current.filter((sKI) => {
          return (
            sKI.detailKategoriInsidenId !==
            (value.length > 1
              ? value[selectedKategoriInsiden.length]
              : value[0])
          );
        })
      );
    }
    // Jika tidak ada
    else {
      let temp1 = listAllKategoriInsiden;

      let idx = temp1.findIndex(
        (item) => item.detailKategoriInsidenId === value[value.length - 1]
      );

      temp1[idx] = {
        ...temp1[idx],
        isCheked: true,
      };

      setSelectedKategoriInsiden((prev) => [...prev, temp1[idx]]);
    }
  };

  const [kategoriInsiden, setKategoriInsiden] = useState(null);
  // Membuat HEADER kategori insiden
  useEffect(() => {
    var data = [];

    listAllKategoriInsiden?.forEach((item) => {
      // Jika data kosong
      if (data.length === 0) {
        data.push({
          id: item.kategoriInsidenId,
          name: item.kategoriInsidenName,
          idHipo: item.idKategoriHipo,
          isInput: item.detailKategoriInsidenId === null,
        });
      } else if (
        !data.find((it) => {
          return it.id === item.kategoriInsidenId;
        })
      ) {
        data.push({
          id: item.kategoriInsidenId,
          name: item.kategoriInsidenName,
          idHipo: item.idKategoriHipo,
          isInput: item.detailKategoriInsidenId === null,
        });
      }
    });

    setKategoriInsiden(data);
  }, []);

  const handleChangeLainnya = (e) => {
    const obj = listAllKategoriInsiden.find((o) => o.kategoriInsidenId === 6);
    let newList = selectedKategoriInsiden.filter(
      (o) => o.kategoriInsidenId !== 6
    );

    if (e.target.value) {
      newList.push({
        ...obj,
        isCheked: true,
        detailKategoriInsidenName: e.target.value,
      });
    }

    setSelectedKategoriInsiden(newList);
  };

  // Handle Map dan Titik Kejadian
  const [isModal, setIsModal] = useState(false);
  const handleClick = () => {
    if (isModal === false) {
      setIsModal(true);
    } else {
      setIsModal(false);
    }
  };
  const ShowMap = () => {
    setIsModal(true);
  };

  // User location for backup pin
  const [longtitude, setLongtitude] = useState(0);
  const [latitude, setLatitude] = useState(0);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setLatitude(position.coords.latitude);
      setLongtitude(position.coords.longitude);
    });
  }, []);

  const handlePosisiChange = ({ lat, long }) => {
    setInputFields({
      ...inputFields,
      locationTagLong: long,
      locationTagLat: lat,
    });
  };

  // Handle Kriteria Pencatatan
  const radioRecordabledHandler = (status) => {
    setShowRecordable(status);
  };

  const shouldKategoriIncidentDisabled = (id) => {
    const obj = selectedKategoriInsiden.find((o) => o.kategoriInsidenId === id);
    return selectedKategoriInsiden.length === 0 ? false : obj ? false : true;
  };

  return (
    <div>
      <Box component="div" sx={boxStyles}>
        <center>
          <h3
            style={{
              color: 'black',
            }}
          >
            INFORMASI KEJADIAN
          </h3>
        </center>
        <SimpleMDE
          value={inputFields.deskripsiSingkat}
          // options={{
          //   //spellChecker: false,
          //   hideIcons: [
          //     "link",
          //     "image",
          //     "preview",
          //     "fullscreen",
          //     "guide",
          //     "side-by-side",
          //   ],
          // }}
          onChange={(value) => {
            setInputFields({
              ...inputFields,
              deskripsiSingkat: value,
            });
          }}
        />
        <br></br>
        <br></br>
        <Grid container spacing={3}>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <FormControl fullWidth variant="standard">
              <InputLabel shrink={true}>Titik Kejadian (maps)</InputLabel>
              <Input
                id="standard-adornment-password"
                type="text"
                value={
                  inputFields.locationTagLong +
                  ', ' +
                  inputFields.locationTagLat
                }
                fullWidth
                // notched={true}
                onChange={(e) =>
                  enableEditMap && handlePosisiChange(e.target.value)
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={ShowMap} disabled={!enableOpenMap}>
                      <AddLocationIcon />
                    </IconButton>
                  </InputAdornment>
                }
                disabled
              />
            </FormControl>
          </Grid>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <TextField
              name="namaLokasiOnMap"
              label="Nama Lokasi di Map"
              variant="standard"
              fullWidth
              value={inputFields.namaLokasiOnMap}
              onChange={(e) => {
                setInputFields({
                  ...inputFields,
                  namaLokasiOnMap: e.target.value,
                });
              }}
              disabled={readOnly}
            />
          </Grid>

          <Grid item xl={12} lg={12} sm={12} xs={12}>
            <TextField
              name="text1"
              label="Perusahaan Terlibat"
              variant="standard"
              fullWidth
              value={inputFields.perusahaanTerlibat}
              onChange={(e) => {
                setInputFields({
                  ...inputFields,
                  perusahaanTerlibat: e.target.value,
                });
              }}
              disabled={readOnly}
            />
          </Grid>
        </Grid>
        <br></br>
        <FormControl>
          <FormLabel id="radio1">
            <b>
              Kategori Hipo <small>(High Potential)</small>
            </b>
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="radio1"
            name="row-radio-buttons-group"
            onChange={(e) => {
              setInputFields({
                ...inputFields,
                isHipo: e.target.value,
              });
            }}
            value={inputFields.isHipo}
            disabled={readOnly}
          >
            {/* Hardcode */}
            <FormControlLabel
              key={1}
              value={true}
              control={<Radio />}
              label={'Hipo'}
              disabled={readOnly}
            />
            <FormControlLabel
              key={2}
              value={false}
              control={<Radio />}
              label={'Non - Hipo'}
              disabled={readOnly}
            />
          </RadioGroup>
          <Paper
            style={{
              padding: '20px',
              backgroundColor: '#ffff00',
              marginBottom: '20px',
              marginTop: '10px',
            }}
          >
            <Typography variant="subtitle1" gutterBottom>
              High Potential Incident (HIPO) adalah jika suatu peristiwa yang
              tidak diinginkan berpotensi mengakibatkan hal yang serius dalam hal
              ini insiden kategori significant dan/atau catastrophic.
            </Typography>
          </Paper>
          <HipoTable difficultyPriorityData={null} />
        </FormControl>
        <Grid container spacing={2}>
          <Grid item>
            <br />
            <FormControl>
              <FormLabel id="radio1">
                <b>Kategori Incident</b>
              </FormLabel>
            </FormControl>
          </Grid>

          <Grid
            item
            container
            xl={12}
            lg={12}
            sm={12}
            xs={12}
            rowSpacing={2}
            columnSpacing={2}
          >
            {kategoriInsiden !== null &&
              kategoriInsiden.map((kate) => (
                <Grid item xs={6} key={kate.id}>
                  {kate.isInput === false ? (
                    <FormControl fullWidth>
                      <FormLabel id={`select-label-${kate.id}`}>
                        {kate.name}
                      </FormLabel>
                      <Select
                        labelId={`select-label-${kate.id}`}
                        id="demo-multiple-checkbox"
                        multiple
                        value={selectedKategoriInsiden}
                        onChange={(e) =>
                          handleChangeKategoriInsiden(e, kate.id)
                        }
                        input={
                          <OutlinedInput
                            id="select-multiple-chip"
                            label="Chip"
                          />
                        }
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: 0.5,
                            }}
                          >
                            {selected.map(
                              (kItem) =>
                                kItem.kategoriInsidenId === kate.id && (
                                  <Chip
                                    key={kItem.detailKategoriInsidenId}
                                    label={
                                      listAllKategoriInsiden.find(
                                        (e) =>
                                          e.detailKategoriInsidenId ===
                                            kItem.detailKategoriInsidenId &&
                                          kItem.isCheked === true
                                      ).detailKategoriInsidenName
                                    }
                                  ></Chip>
                                )
                            )}
                          </Box>
                        )}
                        MenuProps={MenuProps}
                        disabled={
                          readOnly || shouldKategoriIncidentDisabled(kate.id)
                        }
                      >
                        {listAllKategoriInsiden.map(
                          (item) =>
                            kate.id === item.kategoriInsidenId &&
                            item.detailKategoriInsidenId !== null && (
                              <MenuItem
                                key={item.detailKategoriInsidenId}
                                value={item.detailKategoriInsidenId}
                              >
                                <Checkbox
                                  checked={
                                    selectedKategoriInsiden
                                      .map(
                                        (sItem) => sItem.detailKategoriInsidenId
                                      )
                                      .indexOf(item.detailKategoriInsidenId) >
                                      -1 ||
                                    selectedKategoriInsiden
                                      .map(
                                        (sItem) => sItem.detailKategoriInsidenId
                                      )
                                      .indexOf(item.isCheked === true) > -1
                                  }
                                />
                                <ListItemText
                                  primary={item.detailKategoriInsidenName}
                                />
                              </MenuItem>
                            )
                        )}
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      name="text1"
                      label="Lainnya"
                      variant="standard"
                      fullWidth
                      value={
                        shouldKategoriIncidentDisabled(6) === false
                          ? selectedKategoriInsiden[0]
                              ?.detailKategoriInsidenName
                          : ''
                      }
                      onChange={(e) => handleChangeLainnya(e)}
                      disabled={readOnly || shouldKategoriIncidentDisabled(6)}
                    />
                  )}
                </Grid>
              ))}
          </Grid>
        </Grid>
        <Box maxWidth="md">
          <p style={{ color: 'red' }}>
            <small>
              <i>
                *) untuk kasus-kasus terkait dengan aspek securiti, dapat
                menggunakan format tersendiri (misal BAP) sesuai dengan
                ketentuan yang berlaku
              </i>
            </small>
          </p>
        </Box>
        <h4>Kriteria Pencatatan Insiden</h4>
        <Stack spacing={2} direction="row">
          <Box component="div" sx={fieldStyles}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="reportable"
                name="row-radio-buttons-group"
                defaultValue={inputFields.isReportAble}
                onChange={(e) => {
                  setInputFields({
                    ...inputFields,
                    isReportAble: e.target.value === 'true',
                    isRecordAble: false,
                    isWorkRelated: false,
                  });
                }}
                disabled={readOnly}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Reportable"
                  disabled={readOnly}
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="Non Reportable"
                  disabled={readOnly}
                />
              </RadioGroup>
            </FormControl>
          </Box>
          {inputFields.isReportAble === 'true' ||
            (inputFields.isReportAble === true && (
              <Box component="div" sx={fieldStyles}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="radio1"
                    name="row-radio-buttons-group"
                    defaultValue={inputFields.isWorkRelated}
                    onChange={(e) => {
                      setInputFields({
                        ...inputFields,
                        isWorkRelated: e.target.value === 'true',
                        isRecordAble: false,
                      });
                    }}
                    disabled={readOnly}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Work Related"
                      disabled={readOnly}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="Non Work Related"
                      disabled={readOnly}
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            ))}
          {inputFields.isWorkRelated === 'true' ||
            (inputFields.isWorkRelated === true && (
              <Box component="div" sx={fieldStyles}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="radio1"
                    name="row-radio-buttons-group"
                    defaultValue={inputFields.isRecordAble + ''}
                    onChange={(e) => {
                      radioRecordabledHandler(e.target.value);
                      setInputFields({
                        ...inputFields,
                        isRecordAble: e.target.value === 'true',
                      });
                    }}
                    disabled={readOnly}
                  >
                    <FormControlLabel
                      value={'true'}
                      control={<Radio />}
                      label="Recordable"
                      disabled={readOnly}
                    />
                    <FormControlLabel
                      value={'false'}
                      control={<Radio />}
                      label="Non Recordable"
                      disabled={readOnly}
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            ))}
        </Stack>
        <Paper
          style={{
            padding: '20px',
            backgroundColor: '#ffff00',
            marginTop: '20px',
          }}
        >
          <Typography variant="h6" gutterBottom>
          Penentuan Kriteria Pencatatan Insiden Ref Pedoman Klasifikasi & Pencatatan Insiden No. A-001/S00100/2018-S9 yang diterbitkan oleh HSSE Holding
          </Typography>
          {/* <Typography variant="subtitle1" gutterBottom>
            Insiden No. A-001/S00100/2018-S9 yang diterbitkan oleh HSSE Holding
          </Typography> */}
          <Box marginTop={2}>
            <Typography variant="body1" gutterBottom>
              Kategori Recordable Insiden:
            </Typography>
            <Typography variant="body1" component="div">
              1. Melebihi First Aid Case (MTC ke atas)
            </Typography>
            <Typography variant="body1" component="div">
              2. Process Safety (LOPC) TIER I, II, III
            </Typography>
            <Typography variant="body1" component="div">
              3. NoA (Fatality, Oil Spill diatas 15 Barrel, Kerusakan asset diatas 1 juta USD)
            </Typography>
          </Box>
        </Paper>
        <SelectMap
          isModal={isModal}
          handleClick={handleClick}
          text={{
            features: [
              {
                geometry: {
                  coordinates: [
                    inputFields.locationTagLat || latitude,
                    inputFields.locationTagLong || longtitude,
                  ],
                },
              },
            ],
            query: 'new location',
          }}
          disabled={!enableEditMap}
          setPosisi={handlePosisiChange}
        />
      </Box>
    </div>
  );
};

export default InformasiKejadian;
